'use client';

import type { AuthStore } from '../../stores/useAuthStore';
import { HttpStatusCode } from 'axios';
import { tsrClient } from '@/libs/ts-rest/ts-client';

type Error = {
	status: number;
};

export const useSession = (user: AuthStore['user']) => {
	return tsrClient.web.auth.getSession.useQuery({
		queryKey:             [ 'session' ],
		enabled:              user === null,
		refetchOnWindowFocus: false,
		select:               data => data.body.data,
		retry:                (retryAmount, error: unknown) => {
			const { status } = error as unknown as Error;
			const isForbiddenOrUnauthorized = [
				HttpStatusCode.Forbidden,
				HttpStatusCode.Unauthorized,
			].includes(status);

			if (isForbiddenOrUnauthorized) return false;

			return retryAmount < 3;
		},
	});
};